import { authModal, createResvButtons, decrypt } from '@/js/components/common'
import gtag, { install } from 'ga-gtag'
import SmoothScroll from 'smooth-scroll'

const main = () => {
    if (!document.querySelector('#page-special')) return false;
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    let authChkPasswd = false

    let ga_id
    if (document.querySelector('meta[name="ga_id"]')) {
        let options = document.domain == 'francerestaurantweek.com' ? {} : { debug_mode: true }
        ga_id = document.querySelector('meta[name="ga_id"]').getAttribute('content')
        install(ga_id, options)
    }

    const toggleDeteil = event => {
        let obj = $(event.currentTarget).closest('article')
        if (obj.hasClass('open')) {
            obj.removeClass('open')
            $(event.currentTarget).find('a').text('レストラン詳細')
        } else {
            obj.addClass('open')
            $(event.currentTarget).find('a').text('詳細を閉じる')
        }
    }

    const setPrice = (target, encrypt, password) => {
        const decrypted = decrypt(encrypt, password);
        if (!decrypted) return false;
        const data = JSON.parse(decrypted);
        target.text(Number(data.course_price).toLocaleString());
    }

    $('.sec-gourmand.normal .restaurant-list article .more a').on('click', e => {
        toggleDeteil(e)
    })

    $('.sec-gourmand.premium .restaurant-list article .more a').on('click', async (e) => {
        const target = $(e.currentTarget)
        const parent = target.closest('article')
        const encrypt = target.attr('data-encrypt')
        const authChkPasswd = sessionStorage.getItem("resv_premium_key")

        if (authChkPasswd) {
            setPrice(parent.find('.course-price'), encrypt, authChkPasswd)
            createResvButtons(encrypt, authChkPasswd, parent.find('.detail-reserve'))
            toggleDeteil(e)
            return
        }
        let resp = await authModal('premium', { token, encrypt })
            .catch((e) => {
                throw e;
            })
        if (resp.success) {
            sessionStorage.setItem("resv_premium_key", resp.password);
            setPrice(parent.find('.course-price'), encrypt, resp.password)
            createResvButtons(encrypt, resp.password, parent.find('.detail-reserve'))
            toggleDeteil(e)
        }
    })

    $('.sec-gourmand.normal .reserve .button.approval').on('click', async (e) => {
        const stage = $(e.currentTarget).attr('data-stage')
        const encrypt = $(e.currentTarget).attr('data-encrypt')
        let resp = await authModal(stage, { token, encrypt })
            .catch((e) => {
                throw e;
            })
        if (resp.success) {
            sessionStorage.setItem(`resv_${stage}_key`, resp.password);
            $('.sec-gourmand.normal .button.approval').each((i, obj) => {
                const encrypt = $(obj).attr('data-encrypt')
                if (!encrypt) return true;
                createResvButtons(encrypt, resp.password, $(obj).parent())
            });
        }
    });

    $('.sec-gourmand.normal .restaurant-list article').each((i, e) => {
        const target = $(e);
        const dataArea = target.attr('data-area');
        $(`.sec-gourmand.normal .restaurant-list__area a[data-area="${dataArea}"]`).parent().addClass('is-show');
    });
    $('.sec-gourmand.premium .restaurant-list article').each((i, e) => {
        const target = $(e);
        const dataArea = target.attr('data-area');
        $(`.sec-gourmand.premium .restaurant-list__area a[data-area="${dataArea}"]`).parent().addClass('is-show');
    });

    $('.sec-gourmand.normal .restaurant-list__area a').on('click', (e) => {
        const targetKey = $(e.currentTarget).attr('data-area');
        const scroll = new SmoothScroll();
        const anchor = document.querySelector(`.sec-gourmand.normal .restaurant-list article[data-area="${targetKey}"]`);
        scroll.animateScroll(anchor);
    });

    $('.sec-gourmand.premium .restaurant-list__area a').on('click', (e) => {
        const targetKey = $(e.currentTarget).attr('data-area');
        const scroll = new SmoothScroll();
        const anchor = document.querySelector(`.sec-gourmand.premium .restaurant-list article[data-area="${targetKey}"]`);
        scroll.animateScroll(anchor);
    });

    const authStage = $('main').attr('data-auth-stage');
    let authPassword;

    switch (authStage) {
        case 'premium':
            authPassword = sessionStorage.getItem("resv_premium_key")
            break;
        case 'member':
            authPassword = sessionStorage.getItem("resv_member_key")
            break;
    }
    if (authPassword) {
        $('.sec-gourmand.normal .button.approval').each((i, obj) => {
            const encrypt = $(obj).attr('data-encrypt')
            createResvButtons(encrypt, authPassword, $(obj).parent())
        });
    }
}
export default main;